import HeroSection from "@/components/home/HeroSection";
import ReelsCarouselSection from "@/components/home/ReelsCarouselSection";
import CaseStudiesSection from "@/components/home/CaseStudiesSection";
import CtaSection from "@/components/home/CtaSection";
import ContactSection from "@/components/home/ContactSection";
import AvatarBuilderSection from "@/components/home/AvatarBuilderSection";

export default function Home({user, userCredits}) {
  return (
    <>
      <HeroSection />
      <AvatarBuilderSection user={user} userCredits={userCredits}/>
      <ReelsCarouselSection />
      <CtaSection />
      <ContactSection />
    </>
  );
}
